import React from "react";
import classes from './ItemTransaction.module.scss'
import { useTranslation } from "react-i18next";

export const ItemTransaction = () => {
    const {t} = useTranslation()
    return(
        <div className={classes.transaction}>
            <div className={classes.transaction__token}>
                <img alt='coin' src={require('../../img/cpayLittleCoin.png')} className={classes.transaction__token_img}/>
                <div className={classes.transaction__token__amount}>
                    <p className={classes.transaction__token__amount_descr}>{t('personal.total')}</p>
                    <p className={classes.transaction__token__amount_title}>3 tkn</p>
                </div>
            </div>
            <div className={classes.transaction__price}>
                <p className={classes.transaction__price_descr}>{t('personal.price')}</p>
                <p className={classes.transaction__price_title}>$50</p>
            </div>
            <div className={classes.transaction__date}>
                <p className={classes.transaction__date_descr}>{t('personal.date')}</p>
                <p className={classes.transaction__date_title}>13.09.2022</p>
            </div>
            <div className={classes.transaction__receipt}>
                <p className={classes.transaction__receipt_descr}>{t('personal.receipt')}</p>
                <img alt='receipt' src={require('../../img/pdfReceipt.png')} className={classes.transaction__receipt_img}/>
            </div>
            <div className={classes.transaction__buttons}>
                <button className={classes.transaction__buttons_exchange}>{t('personal.exchange')}</button>
                <button className={classes.transaction__buttons_withdrawal}>{t('personal.withdrawal')}</button>
            </div>
        </div>
    )
}